<template>
    <div class="gray-back" style="height: 100%" >
        <div class="box">
            <van-tabs v-model="active" class="tab-nav" sticky @click="onStatusChange">
                <van-tab title="报名中"></van-tab>
                <van-tab title="报名成功"></van-tab>
                <van-tab title="全部"></van-tab>

                <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
                    <van-list
                            v-model="loading"
                            :finished="finished"
                            finished-text="没有更多了"
                            @load="onLoad"
                    >
                        <div class="row-list" v-for="(order, index) in list" :key="index"
                             @click="goDetail(order)">
                            <div class="justify-space-flex row-title">
                                <div class="title-left flex-start gray">
                                    <img class="row-title-img" src="https://static.dierqudao.com/images/dinghuoxitong/icon-date.png" alt="">
                                    <span>{{order.create_time_str}}</span>
                                </div>

                                <div v-if="order.memberstatus==1" class="title-right gray">
                                    秩序册
                                </div>
                                <div v-else-if="order.memberstatus==2" class="title-right gray">
                                    项目填写
                                </div>
                                <div v-else-if="order.memberstatus==3" class="title-right gray">
                                    人员统计
                                </div>
                                <div v-else-if="order.memberstatus==4" class="title-right gray">
                                    住宿统计
                                </div>
                                <div v-else-if="order.memberstatus==5" class="title-right">
                                    等待付款
                                </div>
                                <div v-else-if="order.memberstatus==6" class="title-right green">
                                    报名成功
                                </div>
                                <div v-else-if="order.memberstatus==-1" class="title-right gray">
                                    弃权
                                </div>
                                <div v-else-if="order.memberstatus==-2" class="title-right gray">
                                    待审核
                                </div>
                                <div v-else-if="order.memberstatus==-3" class="title-right">
                                    审核失败
                                </div>
                            </div>
                            <div class="justify-space-flex row-goods"  >
                                <div class="row-left flex-start">
                                    <div class="goods-detail">
                                        <div class="goods-name">{{order.saiqu_name}}</div>
                                        <div class="goods-weight gray-light">
                                            {{order.mingcheng}}
                                        </div>
                                    </div>
                                </div>
                                <div class="row-right">
                                    <div class="goods-price" ><span>¥</span>{{order.total_price}}</div>
                                    <div class="goods-num gray-light">参赛人数 {{order.membercount}}</div>
                                    <!-- <div class="goods-num gray-light">食宿人数 {{order.sai_member_count}}</div> -->
                                    <div class="goods-num gray-light">食宿缴费人数 {{order.shisu_jf_count}}</div>
                                </div>
                                <van-notice-bar
                                v-if="order.is_offline_un_pay"
                                wrapable
                                :scrollable="false"
                                text="线下付款需要管理员审核，请耐心等待2个工作日左右"
                                />
                            </div>

                            <div class="row-btn">
<!--                                <div class="look-order"  >查看详情</div>-->
                                <div class="look-order" v-if="order.show_upload_video"  >上传视频</div>
                                <div class="look-order" v-if="order.memberstatus==6&&order.is_jizan==1"  >上传集赞</div>
                                <div class="look-order" v-if="order.have_cert "  >下载证书</div>
                                <div @click.stop="orderBu(order)" v-if="order.have_bu"  class="look-order">补缴费用</div>
                                <!-- <div @click.stop="beizhu(order)" v-if="order.memberstatus!=6 && (order.saiqu!=751||order.saiqu!=767)"  class="look-order">支付凭证上传</div> -->
                                <div @click.stop="beizhu(order)" v-if="(order.memberstatus!=6 && (order.saiqu!=751||order.saiqu!=767))||(order.memberstatus==6 && (order.saiqu ==768||order.saiqu ==803))"  class="look-order">支付凭证上传</div>
                                <div @click.stop="successInfo(order)" v-if="order.memberstatus==6"  class="look-order">详情</div>
                                <div @click.stop="onDelete(order)" v-if="order.memberstatus!=6"  class="look-order">删除</div>
                                <div @click.stop="kaipiao(order)" v-if="order.memberstatus==6"  class="look-order">申请开票</div>
<!--                                <div @click.stop="goCpJlApply(order)" v-if="order.memberstatus==6&&order.can_youxiu==1"  class="invite-btn">申报优秀教练员</div>-->

                            </div>
                        </div>
                    </van-list>
                </van-pull-refresh>
            </van-tabs>


        </div>

        <LoginDialog :show="loginShow" @loginSuccess="loginSuccess" @loginCancel="loginCancel" />
    </div>
</template>
<style scoped>
    .box {
        /*margin-bottom: 50px;*/
        background: rgba(248,248,248,1);
        min-height: 90vh;
    }
    .van-pull-refresh{
        margin-top: 0.3rem
    }
    .title-left span{
        font-size:14px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(0,0,0,1);
    }
    .normal-btn {
        font-size:12px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(0,0,0,1);
        line-height:26px;
        width:75px;
        height:26px;
        border-radius:13px;
        border:1px solid rgba(0,0,0,1);
        margin-right: 0.5rem;
    }

    .count_edit {
        width:87px;
        height:26px;
        background:linear-gradient(90deg,rgba(254,200,53,1) 0%,rgba(255,173,25,1) 100%);
        border-radius:13px;
        font-size:12px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(255,255,255,1);
        line-height:26px;
        margin-right: 0.5rem
    }

    .row-list {
        border-bottom: 0.1rem solid #EFEFEF;
        background: #fff;
        margin: 0.2rem;
        border-radius: 0.2rem;
    }

    .row-title-img {
        width: 0.4rem;
        height: 0.4rem;
        margin-right: 0.1rem;
    }

    .row-title {
        padding: 0.1rem 0.33rem;
    }

    .title-right {
        color: #FD2840;
    }



    .row-left {
        width: 80%;
    }

    .row-right {
        text-align: center;
    }

    .goods-detail {
        width: 72%;
    }

    .row-left-img {
        width: 1.44rem;
        height: 1.44rem;
        border-radius: 5px;
        margin-right: 0.2rem;
    }

    .row-goods {
        padding: 0.2rem 0.3rem;
        border-bottom: 1px solid #EFEFEF;
    }

    .goods-name {
        font-size: 12px;
        margin-bottom: 0.6rem;
    }

    .goods-price {
        font-size: 16px;
        margin: 0.1rem 0 0.6rem;
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:500;
        color:rgba(253,40,64,1);
    }

    .goods-price span {
        font-size: 12px;
    }

    .goods-num {
        font-size: 12px;
        text-align: left;
    }
    .pay_order{
        width:87px;
        height:26px;
        background:linear-gradient(90deg,rgba(254,200,53,1) 0%,rgba(255,173,25,1) 100%);
        border-radius:13px;
        font-size:12px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(255,255,255,1);
        line-height:26px;
        margin-right: 0.5rem
    }

    .row-btn {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        padding: 0.2rem 0.33rem;
        font-size: 12px;
        text-align: center;
        line-height: 0.52rem;
    }

    .look-order {
        font-size:12px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(0,0,0,1);
        line-height:26px;
        /* width:75px; */
        padding:0px 10px;
        height:26px;
        border-radius:13px;
        border:1px solid rgba(0,0,0,1);
        margin-right: 0.2rem;
    }

    .invite-btn {
        /*width: 2.1rem;*/
        height: 0.52rem;
        padding: 0 10px;
        background:  linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%);
        /*border: 1px solid rgba(255, 0, 0, 1);*/
        border-radius: 0.26rem;
        color: #fff;
    }

</style>

<script>
    import Vue from 'vue';

    import LoginDialog from '@/components/LoginDialog.vue';
    import {Cell, CellGroup, Toast, Dialog, Icon, PullRefresh, List, Tag, Button,DropdownMenu, DropdownItem,
            Tab,
            Tabs,
            NoticeBar,
    } from 'vant';

    Vue.use(Cell).use(CellGroup).use(Toast).use(Dialog).use(Icon).use(Tag).use(Button).use(DropdownMenu).use(Tab).use(Tabs).use(DropdownItem);
    export default {
        name: 'GoodsList',
        components: {
            [PullRefresh.name]: PullRefresh,
            [List.name]: List,
            LoginDialog,
        },
        data: function () {
            return {
                loginShow: false,
                active: 0,
                isLoading: false,
                loading: false,
                finished: false,
                params: {
                    pageNo: 1,
                    pageSize: 5,
                    status: 1
                },
                homeTop : 0,
                list: [],
                userType:2
            }
        },
        mounted() {
            document.title = "报名记录"

            let that = this;
            // console.log(this.$route.meta)
            if (!this.$route.meta.isBack) {
                // 清空查询条件和数据
                that.list = [];
                that.active =0;
                that.params.pageNo = 1;
                that.params.status = 1;
                that.loading = true;
                that.finished = false;
                that.getList()

                if (this.$route.query.status) {
                    that.active = that.params.status = this.$route.query.status;
                    console.log(that.active)
                }
            }
            document.getElementById('app').scrollTop = this.homeTop || 0
            this.$route.meta.isBack = false;

        },
        destroyed() {
        },
        methods: {
            getList() {
                let that = this;
                that.$api.get('/api/sai/applylist', that.params, (res) => {
                    that.loading = false;

                    if (res.data.currentpage == 1) {
                        that.isLoading = false;
                        that.list = res.data.list
                    } else {
                        let list = that.list.concat(res.data.list);

                        that.list = list;
                    }

                    if (res.data.list.length == 0) {
                        that.finished = true;
                    }
                    that.params.pageNo += 1;
                }, (res) => {
                    that.loading = false;
                    that.isLoading = false;
                    if (res.code == 401 || res.code == 402) {
                        if (window.isApp()) {
                            rbLink({
                                name: 'login',
                                query: {},
                            }, 'replace');
                            return;
                        }
                        that.loginShow = true;
                    } else {
                        Toast(res.msg);
                    }
                })
            },


            // 上拉加载
            // （页面显示没有更多了的原因 ）数据加载过慢 导致第一页数据未获取到时，已经请求第二页数据了
            // 可以延迟异步的时间
            onLoad() {
                // console.log(1)
                // 异步更新数据
                console.log('this.params.pageNo')

                if (this.params.pageNo > 1) {
                    setTimeout(() => {
                        this.getList()
                    }, 500);
                }

            },

            // 跳转订单详情
            goDetail(  order) {
                // 判断是否成团
                console.log( order)
                rbLink({
                    'name' : 'ISaiApplyDetail',
                    'query':{
                        id: order.id
                    }
                } )

            },
            goCpJlApply(  order) {
                // 判断是否成团
                console.log( order)
                rbLink({
                    'name' : 'ISaiApplyFormJiaolianCaipan',
                    'query':{
                        id: order.id
                    }
                } )

            },

            action(item,index){
                this.$router.push({
                    name:"QcxjStationApply",
                    query:{
                        id:item.id
                    }
                })

            },

            onRefresh() {
                let that = this;
                that.params.pageNo = 1;
                that.getList();
            },


            // 更改状态
            onStatusChange(index) {

                let status = 0;
                if(index == 0){
                    status = 1
                }else if(index == 1){
                    status = 2
                }else if(index == 2){
                    status = 0
                }
                let that = this;
                that.params.status = status;
                that.params.pageNo = 1;

                // 激活下拉
                that.finished = false;
                that.loading = true;
                that.list = [];

                this.$route.query.status = 0;
                that.getList()
            },


            kaipiao(order){
                if(order.can_kaipiao!=1){
                    Toast('亲在赛后才能开票，而且是电子票哦～');
                    return ;
                }

                rbLink({
                    'name' : 'SaiApplyFapiao',
                    'query':{
                        id: order.id
                    }
                } )
            },

            beizhu(order){
                rbLink({
                    'name' : 'SaiApplyBeizhu',
                    'query':{
                        id: order.id
                    }
                } )
            },
            orderBu(order){
                rbLink({
                    'name' : 'ISaiApplyFormStepBu',
                    'query':{
                        id: order.bu_id
                    }
                } )
            },
            successInfo(order){
                rbLink({
                    'name' : 'ISaiApplyFormSuccess',
                    'query':{
                        id: order.id
                    }
                } )
            },
            onDelete(order){
                let that = this;
                Dialog.confirm({
                    title: '确认',
                    message: '您确定删除报名记录吗?删除后无法恢复'
                }).then(() => {
                    // on confirm
                    that.$api.post('/api/isai/applydelete', {
                        id:order.id
                    }, r => {
                        that.onRefresh();
                    },r=>{
                        that.$toast.fail(r.msg);
                    });
                }).catch(() => {
                    // on cancel
                });
            },

            loginSuccess() {
                this.loginShow = false;
                this.onRefresh();
            },

            loginCancel() {
            },

        }
    }
</script>



// WEBPACK FOOTER //
// SaiApplyList.vue?f2f30eb6